module.exports = __webpack_public_path__ + "img/L_3S.07ce312d.png";